function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 25"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "M14.71 4c-.22-2.1-2.09-4-4.21-4s-4 1.9-4.22 4m1 0c.22-1.58 1.57-3 3.22-3s3 1.42 3.21 3m6.79 21H.5c-.28 0-.5-.22-.5-.5v-20c0-.28.22-.5.5-.5h20c.28 0 .5.22.5.5v20c0 .28-.22.5-.5.5ZM1 24h19V5H1v19Z",
  style: {
    strokeWidth: 0
  }
}));
export { SvgMenuCart as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOTAxNTdkMTIxMzUxODBiNTA5ZDlhZDQ1ZmFjZDQ5NjIuc3ZnIjs=";